import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslationService } from '../service/translation.service';
import { NavbarComponent } from "../components/navbar/navbar.component";
import { NavtabsComponent } from "../components/navtabs/navtabs.component";
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-attestations',
    templateUrl: './attestations.component.html',
    styleUrls: ['./attestations.component.scss'],
    providers: [TranslationService],
    imports: [CommonModule, RouterModule, NavbarComponent, NavtabsComponent],
    standalone: true
})
export class AttestationsComponent implements OnInit, OnDestroy {

  private readonly translationService = inject(TranslationService);

  constructor() {}

  ngOnInit(): void {
   
    this.translationService.get('menu-attestations').subscribe((translation) => {
      document.title = `DIP - ${translation}`;
    });
    document.body.style.backgroundColor="#F1F1F4";
  }
  
  ngOnDestroy(): void {
    document.body.style.backgroundColor="white";
  }

}
